import { useState, useEffect } from 'react'
import { getApplications } from '../api/tapApplications'
import { TapApplication, PaginatedResponse, TapApplicationListParams } from '../types/index'

interface UseApplicationsReturn {
  applications: TapApplication[]
  total: number
  isLoading: boolean
  error: Error | null
  refetch: (params?: TapApplicationListParams) => Promise<void>
}

export const useApplications = (params?: TapApplicationListParams): UseApplicationsReturn => {
  const [applications, setApplications] = useState<TapApplication[]>([])
  const [total, setTotal] = useState(0)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  const refetch = async (newParams?: TapApplicationListParams) => {
    setIsLoading(true)
    setError(null)

    try {
      const data: PaginatedResponse<TapApplication> = await getApplications(newParams || params)
      setApplications(data.items)
      setTotal(data.total)
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Failed to fetch applications')
      setError(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    refetch()
  }, [params])

  return { applications, total, isLoading, error, refetch }
}
